"use client";
import React, { useState } from "react";
import {
  Team,
  Person,
  PersonData,
} from "@/sources/kicker-amateur/types";
import NavBackButton from "@/app/pwa/components/layout/NavBackButton";
import IconEdit from "@/assets/icon/edit.svg";
import { TeamName } from "@/app/pwa/components/team/TeamName";
import {pwaTeamPlayerEditPath, pwaTeamSquadPath} from "@/utils/urlHelper";
import { useRouter } from "next/navigation";
import {subject} from "@casl/ability";
import {useAbility} from "@/app/pwa/lib/ability-context";
import SharePlayerButton from "./SharePlayerButton";

export function TeamPlayerHeader({
  team,
  playerId,
  teamId,
  person
}: {
  team?: Team
  playerId: number
  teamId: number
  person: Person | PersonData
}) {
  const [loading, setLoading] = useState(false)
  // const {
  //   isOpen: isEditOpen,
  //   selectedPlayer: selectedPlayerForEdit,
  //   openModal: openEditModal,
  //   closeModal: closeEditModal,
  // } = usePlayerModal();

  const router = useRouter();
  const ability = useAbility();

  const canEdit = ability.can("update", subject("Function", {teamId: teamId.toString() }));

  return (
    <>
      <div className="border-b border-gray-150">
        <div className="flex justify-center items-center py-2 lg:py-0">
          <div className="lg:hidden flex-1 -ml-3 mr-3">
            <NavBackButton fallbackUrl={pwaTeamSquadPath(teamId.toString())}/>
          </div>
          <h2 className="w-full min-w-0 text-center font-semibold lg:text-left py-2">
            <TeamName team={team} />
          </h2>
          <div className="flex-1 flex justify-end">
          {canEdit && 
            <button
              type="button"
              color="link-muted"
              className="mobile-nav-button"
              onClick={() => {
                setLoading(true)
                team?.Id && router.push(pwaTeamPlayerEditPath(team.Id, playerId))
              }}
              aria-label="Spieler bearbeiten"
            >
              <IconEdit />
            </button>
            }
            {person && team && (
              <SharePlayerButton person={person} team={team}/>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
